import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Block from '../../../components/Block/Block';
import NewsCard from '../../../components/NewsCard/NewsCard';
import NewsModal from '../../../components/NewsModal/NewsModal';
import { fetchNews } from '../../../services/api';
import style from './newsblock.module.scss';

const NewsBlock = () => {
    const [news, setNews] = useState([]);
    const [allNews, setAllNews] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedNews, setSelectedNews] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const navigate = useNavigate();
    
    const NEWS_PER_PAGE = 3;

    useEffect(() => {
        const loadAllNews = async () => {
            setLoading(true);
            try {
                const { data } = await fetchNews({
                    populate: '*',
                    sort: 'publishedAt:desc'
                });
                
                const formattedData = data.map(item => {
                    // Логируем для отладки
                    console.log('News item:', item);
                    console.log('Image data:', item.attributes.Image);
                    
                    // Правильно формируем URL изображения
                    let imageUrl = null;
                    if (item.attributes.Image?.data?.attributes?.url) {
                        // Убираем дублирование слешей
                        const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:1337';
                        const imagePath = item.attributes.Image.data.attributes.url;
                        // Проверяем, начинается ли путь с http
                        if (imagePath.startsWith('http')) {
                            imageUrl = imagePath;
                        } else {
                            // Убираем лишние слеши
                            const cleanPath = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
                            imageUrl = `${baseUrl}${cleanPath}`;
                        }
                    }
                    
                    return {
                        id: item.id,
                        title: item.attributes.Title || 'Без названия',
                        text: item.attributes.Text || 'Нет описания',
                        publishedAt: item.attributes.publishedAt || item.attributes.createdAt,
                        createdAt: item.attributes.createdAt,
                        imageUrl: imageUrl,
                        Image: item.attributes.Image
                    };
                });
                
                console.log('Formatted data:', formattedData);
                
                setAllNews(formattedData);
                setTotalPages(Math.ceil(formattedData.length / NEWS_PER_PAGE));
                setNews(formattedData.slice(0, NEWS_PER_PAGE));
            } catch (error) {
                console.error('Failed to load news:', error);
            } finally {
                setLoading(false);
            }
        };

        loadAllNews();
    }, []);

    const handleLoadMore = () => {
        if (currentPage < totalPages && !isLoadingMore) {
            setIsLoadingMore(true);
            const nextPage = currentPage + 1;
            const start = (nextPage - 1) * NEWS_PER_PAGE;
            const end = start + NEWS_PER_PAGE;
            const newItems = allNews.slice(start, end);
            
            setTimeout(() => {
                setNews(prev => [...prev, ...newItems]);
                setCurrentPage(nextPage);
                setIsLoadingMore(false);
            }, 500);
        }
    };

    const handleNewsClick = (newsItem) => {
        const newsData = {
            id: newsItem.id,
            Title: newsItem.title,
            Text: newsItem.text,
            content: newsItem.text,
            publishedAt: newsItem.publishedAt,
            createdAt: newsItem.createdAt,
            Image: newsItem.Image,
            image: newsItem.imageUrl,
            title: newsItem.title,
            text: newsItem.text
        };
        setSelectedNews(newsData);
    };

    const handleCloseModal = () => {
        setSelectedNews(null);
    };

    const handleButtonClick = () => {
        navigate('/news/');
    };

    return (
        <>
            <Block
                flexDirection="column"
                justifyContent="center"
                alignItems="start"
                width="75%"
                height="fit-content"
                background="rgba(255, 255, 255, 0.92)"
                header="НОВОСТИ"
                className={style.blockWrapper}
            >
                <div className={style.content}>
                    {loading ? (
                        <div className={style.loader}>
                            <div className={style.loaderSpinner}></div>
                            <span>Загрузка новостей...</span>
                        </div>
                    ) : (
                        <>
                            <div className={style.newsgrid}>
                                {news.map((item, index) => (
                                    <div 
                                        key={item.id}
                                        className={style.newsItem}
                                        style={{
                                            animationDelay: `${0.1 + (index % 3) * 0.15}s`
                                        }}
                                    >
                                        <NewsCard
                                            id={item.id}
                                            title={item.title}
                                            text={item.text}
                                            date={item.publishedAt}
                                            image={item.imageUrl}
                                            onClick={() => handleNewsClick(item)}
                                        />
                                    </div>
                                ))}
                            </div>
                            
                            <div className={style.controls}>
                                {currentPage < totalPages && (
                                    <button 
                                        className={style.loadMoreButton}
                                        onClick={handleLoadMore}
                                        disabled={isLoadingMore}
                                    >
                                        {isLoadingMore ? (
                                            <>
                                                <span className={style.spinner}></span>
                                                Загрузка...
                                            </>
                                        ) : (
                                            <>
                                                <svg className={style.buttonIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <path d="M12 5v14M5 12h14"/>
                                                </svg>
                                                Загрузить еще
                                            </>
                                        )}
                                    </button>
                                )}
                                
                                <div className={style.wrapperButton}>
                                    <button 
                                        className={style.customButton}
                                        onClick={handleButtonClick}
                                    >
                                        <span>Все новости</span>
                                        <svg className={style.arrowIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M5 12h14M12 5l7 7-7 7"/>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </Block>

            <NewsModal
                news={selectedNews}
                onClose={handleCloseModal}
            />
        </>
    );
};

export default NewsBlock;